/* Legacy Minted – swipe between product photos on touch screens.
   Works on the LM product page gallery (.lm-pdp__stage). It only toggles the
   same "is-active" classes the thumbnails use, so it never fires clicks,
   cart requests or analytics events. Shows a small "2 / 5" counter. */
(function () {
  function init(stage) {
    if (!stage || stage.__lmSwipe) return;
    var slides = Array.prototype.slice.call(stage.querySelectorAll('.lm-pdp__slide[data-media-id]'));
    if (slides.length < 2) return;
    stage.__lmSwipe = true;

    var media = stage.closest('.lm-pdp__media') || stage.parentNode;
    var count = document.createElement('span');
    count.className = 'lm-pdp__count';
    count.setAttribute('aria-hidden', 'true');
    stage.appendChild(count);

    function activeIndex() {
      for (var i = 0; i < slides.length; i++) if (slides[i].classList.contains('is-active')) return i;
      return 0;
    }
    function syncCount() { count.textContent = (activeIndex() + 1) + ' / ' + slides.length; }

    function go(step) {
      var i = (activeIndex() + step + slides.length) % slides.length;
      var id = slides[i].getAttribute('data-media-id');
      stage.style.setProperty('--lm-swipe-from', step > 0 ? '28px' : '-28px');
      stage.classList.add('lm-swiped');
      slides.forEach(function (s) { s.classList.toggle('is-active', s === slides[i]); });
      media.querySelectorAll('.lm-pdp__thumb').forEach(function (t) {
        var on = t.getAttribute('data-thumb') === id;
        t.classList.toggle('is-active', on);
        if (on && t.parentNode && t.parentNode.scrollWidth > t.parentNode.clientWidth) {
          var row = t.parentNode;
          row.scrollTo({ left: t.offsetLeft - (row.clientWidth - t.offsetWidth) / 2, behavior: 'smooth' });
        }
      });
      syncCount();
    }

    // Start loading the other photos as soon as the shopper touches the gallery.
    var warmed = false;
    function warm() {
      if (warmed) return;
      warmed = true;
      slides.forEach(function (s) { var img = s.querySelector('img'); if (img) img.loading = 'eager'; });
    }

    var sx = 0, sy = 0, tracking = false;
    stage.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) { tracking = false; return; }
      tracking = true;
      sx = e.touches[0].clientX;
      sy = e.touches[0].clientY;
      warm();
    }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (!tracking) return;
      tracking = false;
      var t = e.changedTouches[0];
      var dx = t.clientX - sx, dy = t.clientY - sy;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.2) go(dx < 0 ? 1 : -1);
    }, { passive: true });
    stage.addEventListener('touchcancel', function () { tracking = false; }, { passive: true });

    // Keep the counter right when a thumbnail or a variant changes the photo.
    if (window.MutationObserver) {
      new MutationObserver(syncCount).observe(stage, { subtree: true, attributes: true, attributeFilter: ['class'] });
    }
    syncCount();
  }

  function initAll(root) {
    (root || document).querySelectorAll('.lm-pdp__stage').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();